import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ba167096&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba167096')) {
      api.createRecord('ba167096', component.options)
    } else {
      api.reload('ba167096', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ba167096&", function () {
      api.rerender('ba167096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SIGRzOx1gJCY/JS/pricehelp.vue"
export default component.exports